import Component from '@bythepixel/component-loader';
import BaseForm from './base';

export default class RentalForm extends Component {
  static selector = '[data-comp-form-rental]'

  constructor(containerEl) {
    super(containerEl);

    // eslint-disable-next-line no-new
    new BaseForm(containerEl, `${this.$id}_secureInput`, '/api/leads/rental', () => {
      // Update event label before submission
      this.vehicleType = this.$container.querySelector('select[name="vehicle_type"]');
      this.$container.dataset.eventLabel = this.vehicleType.value;
    });

    this.initModalListener();
  }

  initModalListener() {
    this.modalTriggers = document.querySelectorAll('[data-comp-modal-trigger="rental"]');
    this.vehicleTypeDropdown = this.$container.querySelector('[data-vehicle-types]');

    if (this.modalTriggers.length === 0 || !this.vehicleTypeDropdown) return;

    this.modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const selectedVehicleType = trigger.dataset.compRentalFormSelected;
        // Check if select dropdown has the trigger value
        const check = this.vehicleTypeDropdown.querySelector(`option[value="${selectedVehicleType}"]`);

        if (check) {
          this.vehicleTypeDropdown.value = selectedVehicleType;
        }
      });
    });
  }
}
